import { ReactElement } from 'react';

import { HirePlanForm } from '.';
import { HirePlanFormSectionBase } from '../shared/HirePlanFormSectionBase';

export function HirePlanFormSection(): ReactElement {
  return (
    <HirePlanFormSectionBase
      FormComponent={HirePlanForm}
      primaryRouteId="token-servidor"
      maxWidthClassName="max-w-[1500px]"
      showCoverageButton={false}
    />
  );
}
